import React, { useEffect, useMemo, useState } from "react";
import { Card, Typography, Tag, Space, Button } from "antd";
import { ArrowLeftOutlined, FileTextOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import axiosInstance from "../api/axiosInstance";

//IMPORTANT: Quill viewer styles (for ql-editor formatting)
import "react-quill/dist/quill.snow.css";
import notify from "../utils/notify";

const { Title, Text } = Typography;

export default function TermsOfUsePage({
  appNameFallback = "HMS Platform",
  companyNameFallback = "Nnetego",
}) {
  const navigate = useNavigate();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await axiosInstance.get("/legal/current");
        setDoc(res.data?.terms || null);
      } catch (e) {
        notify.error(e?.response?.data?.message || "Failed to load Terms of Use.");
      }
    })();
  }, []);

  const meta = useMemo(() => {
    // ✅ date only (no time)
    const effective = doc?.effectiveFromUtc
      ? dayjs(doc.effectiveFromUtc).format("DD MMM YYYY")
      : "—";

    return {
      appName: appNameFallback,
      companyName: companyNameFallback,
      version: doc?.version ?? "—",
      effective,
    };
  }, [doc, appNameFallback, companyNameFallback]);

  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "24px 16px" }}>
      <Space style={{ width: "100%", justifyContent: "space-between" }} wrap>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
            Back
          </Button>
          <Tag icon={<FileTextOutlined />}>Legal</Tag>
        </Space>

        <Space>
          <Text type="secondary">
            Version: <Text strong>{meta.version}</Text>
          </Text>
          <Text type="secondary">
            Effective: <Text strong>{meta.effective}</Text>
          </Text>
        </Space>
      </Space>

      <Card style={{ marginTop: 12 }} bordered>
        <Title level={2} style={{ marginTop: 0, marginBottom: 4 }}>
          {doc?.title || "Terms of Use"}
        </Title>

        {/* Quill viewer wrapper + ql-editor so formatting matches editor */}
        <div className="ql-snow" style={{ marginTop: 12 }}>
          <div
            className="ql-editor legal-view"
            dangerouslySetInnerHTML={{ __html: doc?.contentHtml || "<p>Not configured.</p>" }}
          />
        </div>
      </Card>

      {/* optional: small CSS tweaks */}
      <style>{`
        .legal-view { padding: 0; }
        .legal-view p { margin: 0 0 12px; }
        .legal-view h1, .legal-view h2, .legal-view h3 { margin: 16px 0 8px; }
      `}</style>
    </div>
  );
}
